import React from "react";

const CoiCertificateLanguageToggle = ({ manageSwitch, setManageSwitch }) => {
  const handleEnglishSwitch = () => setManageSwitch(false);
  const handleSpanishSwitch = () => setManageSwitch(true);

  return (
    <div className="switches-container mb-30">
      <div className="mempro" onClick={handleEnglishSwitch}>
        English
      </div>
      <div className="mempro" onClick={handleSpanishSwitch}>
        Spanish
      </div>
      <div
        className={
          !manageSwitch ? "switch-wrapper" : "switch-wrapper switchside"
        }
      >
        <div className="switch">
          {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
        </div>
      </div>
    </div>
  );
};

export default CoiCertificateLanguageToggle;
